import { render, staticRenderFns } from "./WorkflowNexusConfigurationDialog.vue?vue&type=template&id=546e38a0"
import script from "./WorkflowNexusConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowNexusConfigurationDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkflowNexusConfigurationDialog.vue?vue&type=style&index=0&id=546e38a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VTextField})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
